import { Typography } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';

export const ApplicationCompleted = () => {
  return (
    <Grid2 container spacing={2}>
      <Grid2 xs={12}>
        <Typography variant="h1">Application Submitted</Typography>
      </Grid2>
      <Grid2 xs={12}>
        <Typography variant="body1">
          Thank you for submitting an online application to Talquin Electric Cooperative.
        </Typography>
      </Grid2>
      <Grid2 xs={12}>
        <Typography variant="body1">
          Your application will be reviewed and processed. A Member Services Representative will contact you, if needed.
        </Typography>
      </Grid2>
    </Grid2>
  );
};
